import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { EvaluationFamilyType } from '@/enums/evaluation/evaluation.enum';
import { EvaluationDetail, EvaluationListItem } from '@/models/evaluation/evaluation.model';

export interface EvaluationRepository {
  getEvaluations(evaluationFamilyType: EvaluationFamilyType): Observable<EvaluationListItem[]>;
  getEvaluationDetail(evaluationId: number): Observable<EvaluationDetail>;
}

export const EVALUATION_REPOSITORY = new InjectionToken<EvaluationRepository>('EVALUATION_REPOSITORY');
